import React from 'react'
import { Menu, Divider, Button } from "antd";
import { Link } from "react-router-dom";
import styled from 'styled-components';
import "./Navbar.css"

function RightMenu() {

    const items = [
    {
        type: "menuGroup",
        label: <Link to="/about">ABOUT</Link>,
        key: "about",
    },
    {
        type: "menuGroup",
        label: <Link to="/space">SPACE</Link>,
        key: "space",
    },
    {
        type: "menuGroup",
        label: <Link to="/schedule">SCHEDULE</Link>,
        key: "schedule",
    },
    {
        type: "menuGroup",
        label: <Link to="/contact">CONTACT</Link>,
        key: "contatct",
    },
    {
        type: "menuGroup",
        label: <Link to="/simulation">SIMULATION</Link>,
        key: "simulation",
    },
  ];


  return (
        <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <Menu items={items} mode={'horizontal'} style={{height:"60px", float:"right", width:"600px", display:"flex", justifyContent:"end", alignItems:"flex-end", border:"none", backgroundColor:"rgba(0,0,0,0)"}}/>
            <Divider type="vertical" style={{ backgroundColor: "darkgray" }} />
            <Button type='primary' style={{marginLeft:"40px", width:"100px", backgroundColor:"rgb(16, 24, 32)", borderColor:"rgb(16, 24, 32)"}}>Sign In</Button>
        </div>
  )
}

export default RightMenu